import TextArea from './TextArea';
import TextAreaSimple from './TextAreaSimple';

export { TextAreaSimple };

export default TextArea;
